import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { Ativacao, Cliente, Midia, VendedorInfo } from '../../models/models';
import { AtivacoesService } from '../../services/ativacoes.service';
import { FirebaseRequestsService } from '../../services/requests/firebase/firebase-requests.service';
import { SecurityService } from '../../services/security.service';
import {
  DialogAvisoAtv14Dias,
  DialogDescadastrarCliente,
  DialogEmail,
  DialogEncerrarAtivacao,
  DialogLigacao,
  DialogNotas,
  DialogWhatsApp,
} from '../dialogs/dialogs';

@Component({
  selector: 'app-ativacao-actions',
  templateUrl: './ativacao-actions.component.html',
  styleUrls: ['./ativacao-actions.component.scss'],
})
export class AtivacaoActionsComponent {
  @Input() modoCampanha!: boolean;
  @Input() cliente: Cliente;
  @Input() ativacao!: Ativacao;
  @Input() currentVendedorInfo!: VendedorInfo;
  @Output() finalizouAtivacao: EventEmitter<boolean> = new EventEmitter();

  constructor(
    public ativacoesService: AtivacoesService,
    public securityService: SecurityService,
    private fireReqs: FirebaseRequestsService,
    private dialog: MatDialog
  ) {}
  
  isArray(variable: any): boolean {
    return Array.isArray(variable);
  }

  encerrarAtivacao(ativacaoAtual: Ativacao) {
    if (ativacaoAtual.executou_acao) {
      this.securityService.mainActivation(ativacaoAtual, null).then((res) => {
        this.finalizouAtivacao.emit(true);
      });
    } else {
      this.dialog
        .open(DialogEncerrarAtivacao, {
          data: ativacaoAtual,
        })
        .afterClosed()
        .subscribe((res) => {
          this.finalizouAtivacao.emit(res);
        });
    }
  }

  get hasWhatsapp() {
    return this.ativacao
      ? this.ativacao.midias.some((midia) => midia.tipo_midia == 'whatsapp')
      : false;
  }

  descadastrarClienteCanal() {
    const data = this.ativacao
      ? this.ativacao
      : {
          id_cliente: this.cliente.id_cliente,
          id_vendedor: this.cliente.id_vendedor_preferencia,
        };

    this.dialog
      .open(DialogDescadastrarCliente, {
        data: data,
      })
      .afterClosed()
      .subscribe((res) => {
        this.finalizouAtivacao.emit(res);
      });
  }

  abrirDialogMidia(ativacao: Ativacao, midia: Midia) {
    if (midia.tipo_midia === 'whatsapp') {
      this.dialog.open(DialogWhatsApp, {
        data: { ativacao: ativacao, midia, modoCampanha: this.modoCampanha },
        disableClose: true,
      });
    }
    if (midia.tipo_midia === 'telefone') {
      this.dialog.open(DialogLigacao, {
        data: { ativacao: ativacao, midia },
        disableClose: true,
      });
    }
    if (midia.tipo_midia === 'email') {
      this.dialog.open(DialogEmail, {
        data: { ativacao: ativacao, midia },
        disableClose: true,
      });
    }
  }

  calcDias(dtUltimaCompra) {
    try {
      const qtdDias = moment().diff(
        moment(dtUltimaCompra, 'YYYY-MM-DD'),
        'days'
      );
      return isNaN(qtdDias) ? 'Erro ao calcular' : qtdDias;
    } catch (e) {
      return 'Erro ao calcular';
    }
  }

  valorReal(valor) {
    return valor.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      style: 'currency',
      currency: 'BRL',
    });
  }

  openNotas(notaType: 'ANOTACAO' | 'LEMBRETE') {
    const dialogRef = this.dialog.open(DialogNotas, {
      data: {
        clienteCpf: this.cliente.cpf,
        clienteSiglaMarca: this.cliente.sigla_marca,
        notaType: notaType,
        cliente: this.cliente,
      },
    });
  }

  openDialogAtvEsp() {
    if (this.cliente.publicacao_atual.ind_ativado_recente) {
      this.dialog
        .open(DialogAvisoAtv14Dias)
        .afterClosed()
        .subscribe((res) => {
          if (res) {
            this.openDialogAtv();
          }
        });
    } else {
      this.openDialogAtv();
    }
  }

  openDialogAtv() {
    const ativacao = {
      id_ativacao: '',
      id_cliente: this.cliente.id_cliente,
      id_vendedor: this.securityService.currentUserValue.id_vendedor,
    } as Ativacao;

    this.dialog
      .open(DialogWhatsApp, {
        data: {
          ativacao,
          midia: {
            celular: this.cliente.telefone,
            texto:
              this.securityService.currentUserValue.empresa.config_crm.appvnd
                .script_ativacao_espontanea,
            tipo_midia: 'whatsapp',
          },
          modoCampanha: this.modoCampanha,
          ativacaoEspontanea: true,
        },
        disableClose: true,
      })
      .afterClosed()
      .subscribe((res) => this.finalizouAtivacao.emit(res));
  }

  getArray(arr: any) {
    return arr ? arr : [];
  }

  getCanal(canalId: string) {
    const canalNames = {
      propria: 'Própria',
      ecommerce: 'E-Commerce',
      franquia: 'Franquia',
    };

    return canalNames[canalId] ? canalNames[canalId] : '';
  }
}
